import { gql } from '@apollo/client';

export const CREDIT_DECISION_PARSED_DATA_FRAGMENT = gql`
  fragment CreditDecisionParsedDataFields on CreditDecisionParsedData {
    parsedDecisionId
    parsedData {
      conditions
      decisionType
      firstPaymentDueDate
      decisionDate
      declineReasons
      interestRate
      lenderFees {
        amount
        canBeFinanced
        description
        feeName
      }
      stipulations
      termLengthMonths
      advancePaymentsCount
      approvalAmount
      expirationDate
      applicantName
      businessName
      monthlyPayment
      downPaymentToVendor
      minimumRequiredDownPayment
      daysToFirstPayment
    }
  }
`;
